<template>
  <!-- 增加修改 -->
  <a-modal :title="formTitle || '新增'" v-model:visible="open" @cancel="onClose" :width="1000" :maskClosable="false"
    :keyboard="false" :destroyOnClose="true" :footer="null" class="create-form-modal">
    <a-form ref="formRef" :model="form" :rules="rules" :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }" class="two-column-form">
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="员工姓名" name="nickName">
            <a-input v-model:value="form.nickName" placeholder="请输入" :maxLength="30" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="员工角色" name="roleIds">
            <a-select v-model:value="form.roleIds" placeholder="请选择" @change="handleRoleChange">
              <a-select-option v-for="(d, index) in roleOptions" :key="index" :value="d.id">
                {{ d.roleName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="性别(身份证识别)" name="sex">
            <a-select v-if="form.rortraitUrl && form.sex !== 1 && form.sex !== 2" v-model:value="form.sex"
              placeholder="请选择性别" allow-clear style="width: 100%">
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
              <a-select-option :value="0">保密</a-select-option>
            </a-select>
            <a-input v-else :value="sexDisplayText" disabled placeholder="请上传人像面自动识别" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="民族" name="nationality">
            <a-input v-model:value="form.nationality" disabled placeholder="请上传人像面自动识别" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="出生年月日" name="birthDate">
            <a-date-picker v-model:value="form.birthDate" style="width: 100%" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
              disabled placeholder="请上传人像面自动识别" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="身份证号" name="idNumber">
            <a-input v-model:value="form.idNumber" disabled placeholder="请上传人像面自动识别" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="身份证有效期开始" name="cardStartTime">
            <a-date-picker v-model:value="form.cardStartTime"
              :disabled="hasIdCardFromApi || !hasIdCardRecognized || (hasIdCardRecognized && !!form.cardStartTime)"
              style="width: 100%" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="请上传国徽面自动识别" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="身份证有效期截止" name="cardEndTime">
            <a-date-picker v-model:value="form.cardEndTime"
              :disabled="hasIdCardFromApi || !hasIdCardRecognized || (hasIdCardRecognized && !!form.cardEndTime)"
              style="width: 100%" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="请上传国徽面自动识别" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="用户手机号" name="phoneNumber">
            <a-input v-model:value="form.phoneNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="电子邮箱" name="email">
            <a-input v-model:value="form.email" placeholder="请输入" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="入职时间" name="entryTime">
            <a-date-picker v-model:value="form.entryTime" style="width: 100%" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
              placeholder="请选择日期" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="离职时间" name="departTime">
            <a-date-picker v-model:value="form.departTime" style="width: 100%" format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD" placeholder="请选择日期" allow-clear :disabled-date="disabledDepartDate"
              :disabled="!isResignedStatus" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="机动人才编号" name="certificateCode">
            <a-input v-model:value="form.certificateCode" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="当前状态" name="userStatus">
            <a-select v-model:value="form.userStatus" @change="handleUserStatusChange">
              <a-select-option :key="item.value" v-for="(item, index) in currentStatusOptions">{{ item.label
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="用户授权平台" name="loginPlatform">
            <a-select v-model:value="form.loginPlatform">
              <a-select-option :key="item.value" v-for="(item, index) in loginPlatformOptions">{{ item.label
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="公司授权" name="deptId">
            <a-tree-select v-model:value="form.deptId" style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="deptOptions" placeholder="请选择"
              :replaceFields="replaceFields" tree-default-expand-all>
            </a-tree-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目授权" name="projectCodes">
            <a-select :value="isAllProjectSelected ? '0' : selectedProjects" placeholder="请选择项目" style="width: 100%"
              :mode="isAllProjectSelected ? undefined : 'multiple'" :disabled="!isManagementRole"
              @change="handleProjectChange">
              <a-select-option value="0">全部项目</a-select-option>
              <a-select-option v-for="project in projectList" :key="project.id" :value="project.id">
                {{ project.chineseName || project.projectCode }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="所在项目" name="projectId">
            <a-select v-model:value="form.projectId" show-search :filter-option="filterProjectOption"
              placeholder="请选择所在项目" style="width: 100%" allow-clear :disabled="isManagementRole"
              @change="handleProjectIdChange">
              <a-select-option v-for="project in projectList" :key="project.id" :value="project.id">
                {{ project.chineseName || project.projectCode }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12" v-if="form.id == undefined">
        <a-col :span="12">
          <a-form-item label="用户登录名" name="userName">
            <a-input v-model:value="form.userName" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="用户密码" name="password">
            <a-input-password v-model:value="form.password" placeholder="请输入" :maxLength="20" />
            <div style="color: #999; font-size: 12px; margin-top: 4px">
              <template v-if="form.id === undefined"> </template>
              <template v-else>
                提示：不填写不修改密码保持原密码，填写了则为新密码
              </template>
            </div>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目排班" name="attendadceId">
            <a-select v-model:value="form.attendadceId" placeholder="请先选择所在项目" style="width: 100%"
              :disabled="!isAttendanceRole || !form.projectId" allow-clear :loading="attendanceLoading">
              <a-select-option v-for="item in attendanceOptions" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12" justify="center">
        <a-col :span="8">
          <a-form-item label="人像面" name="rortraitUrl">
            <file-upload :value="form.rortraitUrl" type="image" :count="1" @change="handleRortraitUrlChange" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="国徽面" name="emblemUrl">
            <file-upload :value="form.emblemUrl" type="image" :count="1" @change="handleEmblemUrlChange" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="机动人才证书" name="certificateUrl">
            <file-upload :value="form.certificateUrl" type="image" :count="3" field-name="certificateUrl"
              @change="handleCertificateUrlChange" />
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 状态字段隐藏，但保留在表单中以便提交时包含 -->
      <!-- <a-form-item label="状态" name="status" v-show="false">
        <a-radio-group v-model:value="form.status" button-style="solid">
          <a-radio-button
            v-for="(d, index) in statusOptions"
            :key="index"
            :value="parseInt(d.value)"
            >{{ d.label }}</a-radio-button
          >
        </a-radio-group>
      </a-form-item> -->

      <!--      <a-form-item label="备注" name="remark">-->
      <!--        <a-input v-model:value="form.remark" placeholder="请输入" type="textarea" allow-clear />-->
      <!--      </a-form-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'

import { getUser, addUser, updateUser } from '@/api/system/user'
import { getInfo } from '@/api/login'
import { listAttendance } from '@/api/system/attendance'
import moment from 'moment'
import { baiduVerification } from '@/api/system/config'

export default {
  name: 'CreateForm',
  props: {
    deptOptions: {
      type: Array,
      required: true,
    },
    loginPlatformOptions: {
      type: Array,
      required: true,
    },
    currentStatusOptions: {
      type: Array,
      required: true,
    },
    sexOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      statusOptions: [
        { value: 0, label: '禁用' },
        { value: 1, label: '启用' },
      ],
      submitLoading: false,
      replaceFields: {
        children: 'children',
        title: 'label',
        key: 'id',
        value: 'id',
      },
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 项目列表
      projectList: [],
      // 考勤规则列表
      attendanceOptions: [],
      attendanceLoading: false,
      // 是否选择了全部项目
      isAllProjectSelected: false,
      // 选中的项目（数组）
      selectedProjects: [],
      // 默认密码
      initPassword: undefined,
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        deptId: 0,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        nationality: undefined,
        birthDate: undefined,
        idNumber: undefined,
        cardStartTime: undefined,
        cardEndTime: undefined,
        entryTime: undefined,
        departTime: undefined,
        certificateCode: undefined,
        userStatus: undefined,
        loginPlatform: undefined,
        projectCodes: undefined,
        projectId: undefined,
        attendadceId: undefined,
        rortraitUrl: undefined,
        emblemUrl: undefined,
        certificateUrl: undefined,
        sex: undefined,
        status: 1,
        remark: undefined,
        postIds: '',
        roleIds: '',
      },
      open: false,
      // 标记是否已经进行过身份证识别
      hasIdCardRecognized: false,
      // 标记身份证有效期是否来自接口（编辑模式）
      hasIdCardFromApi: false,
      rules: {
        userName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
        nickName: [
          { required: true, message: '用户昵称不能为空', trigger: 'blur' },
        ],
        roleIds: [
          { required: true, message: '员工角色不能为空', trigger: 'change' },
        ],
        deptId: [
          { required: true, message: '部门不能为空', trigger: 'change' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            min: 5,
            max: 20,
            message: '用户密码长度必须介于 5 和 20 之间',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: '请正确填写邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        phoneNumber: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: ['blur', 'change'],
          },
        ],
        loginPlatform: [
          {
            required: true,
            message: '用户授权平台不能为空',
            trigger: 'change',
          },
        ],
        userStatus: [
          { required: true, message: '当前状态不能为空', trigger: 'change' },
        ],
        departTime: [
          {
            validator: (rule, value, callback) => {
              // 验证器将在 created 钩子中定义
              if (this.validateDepartTime) {
                this.validateDepartTime(rule, value, callback)
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change'],
          },
        ],
        projectCodes: [
          {
            validator: (rule, value, callback) => {
              // 如果是管理层或营运经理，项目授权必填
              if (this.isManagementRole) {
                if (
                  !value ||
                  value === '' ||
                  (this.isAllProjectSelected === false &&
                    (!this.selectedProjects ||
                      this.selectedProjects.length === 0))
                ) {
                  callback(new Error('项目授权不能为空'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  created() {
    // 初始化离职时间验证器
    // 验证离职时间必须在入职时间之后
    this.validateDepartTime = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      if (!this.form.entryTime) {
        callback()
        return
      }
      const entryTime = new Date(this.form.entryTime)
      const departTime = new Date(value)
      if (departTime < entryTime) {
        callback(new Error('离职时间不能早于入职时间'))
      } else {
        callback()
      }
    }
    this.getConfigKey('sys.user.initPassword').then((response) => {
      this.initPassword = response.msg
    })
    this.getProjectList()
  },
  computed: {
    /**
     * 性别显示文本
     */
    sexDisplayText() {
      if (this.form.sex === undefined || this.form.sex === null) {
        return ''
      }
      // 直接根据 form.sex 的值返回对应的文本
      if (this.form.sex === 1) {
        return '男'
      } else if (this.form.sex === 2) {
        return '女'
      } else if (this.form.sex === 0) {
        return '保密'
      }
      // 如果 sexOptions 存在，尝试从选项中查找
      if (this.sexOptions && this.sexOptions.length > 0) {
        const sexOption = this.sexOptions.find(
          (option) => parseInt(option.value) === parseInt(this.form.sex)
        )
        if (sexOption) {
          return sexOption.label
        }
      }
      return ''
    },
    /**
     * 判断当前选中的角色是否是管理层或营运经理
     * @returns {Boolean} true-是管理层或营运经理，false-不是
     */
    isManagementRole() {
      if (
        !this.form.roleIds ||
        !this.roleOptions ||
        this.roleOptions.length === 0
      ) {
        return false
      }
      const selectedRole = this.roleOptions.find(
        (role) => role.id === this.form.roleIds
      )
      if (!selectedRole) {
        return false
      }
      const roleName = selectedRole.roleName || ''
      // 判断是否是管理层或营运经理
      return roleName === '管理层' || roleName === '营运经理'
    },
    /**
     * 判断当前选中的角色是否是项目主管或保洁员工
     * @returns {Boolean}
     */
    isAttendanceRole() {
      if (
        !this.form.roleIds ||
        !this.roleOptions ||
        this.roleOptions.length === 0
      ) {
        return false
      }
      const selectedRole = this.roleOptions.find(
        (role) => role.id === this.form.roleIds
      )
      if (!selectedRole) {
        return false
      }
      const roleName = selectedRole.roleName || ''
      return roleName === '项目主管' || roleName === '保洁员工'
    },
    isResignedStatus() {
      return this.form.userStatus === '0' || this.form.userStatus === 0
    },
  },
  watch: {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        nationality: undefined,
        birthDate: undefined,
        idNumber: undefined,
        cardStartTime: undefined,
        cardEndTime: undefined,
        entryTime: undefined,
        departTime: undefined,
        certificateCode: undefined,
        userStatus: undefined,
        loginPlatform: undefined,
        projectCodes: undefined,
        projectId: undefined,
        attendadceId: undefined,
        rortraitUrl: undefined,
        emblemUrl: undefined,
        certificateUrl: undefined,
        sex: undefined,
        status: 1,
        remark: undefined,
        postIds: '',
        roleIds: '',
      }
      // 重置识别标记
      this.hasIdCardRecognized = false
      this.hasIdCardFromApi = false
      this.selectedProjects = []
      this.attendanceOptions = []
      this.attendanceLoading = false
      this.getProjectList()
      this.isAllProjectSelected = false
    },
    /**
     * 处理员工角色变化
     * 如果是管理层或营运经理，清空当前项目字段并触发验证
     * 如果不是管理层或营运经理，清空项目授权字段
     */
    handleRoleChange() {
      if (this.isManagementRole) {
        // 如果是管理层或营运经理，清空当前项目
        this.form.projectId = undefined
        // 触发项目授权字段的验证
        this.$nextTick(() => {
          if (this.$refs.formRef) {
            this.$refs.formRef.validateFields(['projectCodes'])
          }
        })
      } else {
        // 如果不是管理层或营运经理，清空项目授权相关字段
        this.form.projectCodes = undefined
        this.isAllProjectSelected = false
        this.selectedProjects = []
        // 清除项目授权字段的验证错误
        this.$nextTick(() => {
          if (this.$refs.formRef) {
            this.$refs.formRef.clearValidate(['projectCodes'])
          }
        })
      }
      if (!this.isAttendanceRole) {
        this.form.attendadceId = undefined
      }
      this.loadAttendanceOptions()
    },
    /** 获取项目列表（和 RightContent.vue 一样的数据源） */
    getProjectList() {
      getInfo()
        .then((res) => {
          if (res.success && res.data) {
            // 从用户信息中获取项目列表
            const projectInfoList = res.data.projectInfoList || []
            this.projectList = Array.isArray(projectInfoList)
              ? projectInfoList
              : []
          } else {
            this.projectList = []
          }
        })
        .catch(() => {
          this.projectList = []
        })
    },
    /** 项目选择变化时加载考勤规则 */
    handleProjectIdChange() {
      this.loadAttendanceOptions()
    },
    /** 根据角色和项目加载考勤规则 */
    loadAttendanceOptions() {
      if (!this.isAttendanceRole || !this.form.projectId) {
        this.attendanceOptions = []
        if (!this.isAttendanceRole) {
          this.form.attendadceId = undefined
        }
        return
      }
      this.attendanceLoading = true
      listAttendance({
        projectId: this.form.projectId,
        status: 1,
      })
        .then((res) => {
          const list = Array.isArray(res.data) ? res.data : []
          this.attendanceOptions = list.map((item) => ({
            id: item.id,
            name: item.name,
          }))
          if (
            this.form.attendadceId !== undefined &&
            this.form.attendadceId !== null
          ) {
            const currentId = this.form.attendadceId
            const exists = this.attendanceOptions.some(
              (option) => option.id == currentId
            )
            if (!exists) {
              this.form.attendadceId = undefined
            } else {
              this.form.attendadceId = currentId
            }
          }
        })
        .finally(() => {
          this.attendanceLoading = false
        })
    },
    /** 过滤项目选项（和 RightContent.vue 一样的过滤逻辑） */
    filterProjectOption(input, option) {
      if (!input) return true
      const value = option.componentOptions.propsData.value
      const project = this.projectList.find((p) => p.id === value)
      if (project) {
        const searchText = input.toLowerCase()
        const chineseName = (project.chineseName || '').toLowerCase()
        const projectCode = (project.projectCode || '').toLowerCase()
        return (
          chineseName.indexOf(searchText) >= 0 ||
          projectCode.indexOf(searchText) >= 0
        )
      }
      return false
    },
    /** 处理项目选择变化 */
    handleProjectChange(value) {
      // 如果选择了"全部项目"（值为"0"）
      if (value === '0' || (Array.isArray(value) && value.includes('0'))) {
        this.isAllProjectSelected = true
        this.selectedProjects = []
        this.form.projectCodes = '0'
      } else {
        this.isAllProjectSelected = false
        // 如果是数组，过滤掉"0"和无效值
        if (Array.isArray(value)) {
          this.selectedProjects = value.filter(
            (v) => v !== '0' && v !== undefined && v !== null
          )
          this.form.projectCodes = this.selectedProjects.join(',')
        } else {
          this.selectedProjects = value ? [value] : []
          this.form.projectCodes = this.selectedProjects.join(',')
        }
      }
    },
    /** 处理人像面上传 */
    handleRortraitUrlChange(url) {
      this.form.rortraitUrl = url
      if (url) {
        // 上传人像面时，立即标记已进行身份证识别，允许用户手动选择性别
        this.hasIdCardRecognized = true
        // 重置性别为 undefined，等待识别结果
        this.form.sex = undefined
        this.callBaiduIdCardRecognition(url, 'front')
      } else {
        // 图片删除后，清空通过识别API设置的字段
        this.form.nickName = undefined
        this.form.nationality = undefined
        this.form.birthDate = undefined
        this.form.idNumber = undefined
        this.form.sex = undefined
        this.hasIdCardRecognized = false // 清除人像面时，重置识别标记
      }
    },
    /** 处理国徽面上传 */
    handleEmblemUrlChange(url) {
      this.form.emblemUrl = url
      // 上传完成后，调用百度身份证识别API进行信息回填
      if (url) {
        this.hasIdCardRecognized = true // 标记已进行身份证识别
        this.callBaiduIdCardRecognition(url, 'back')
      } else {
        // 图片删除后，清空通过识别API设置的字段
        this.hasIdCardRecognized = false // 重置识别标记
        this.form.cardStartTime = undefined
        this.form.cardEndTime = undefined
      }
    },
    /**
     * 调用百度身份证识别API
     * @param {String} imageUrl 图片URL
     * @param {String} idCardSide 身份证正反面：front-正面，back-背面
     */
    callBaiduIdCardRecognition(imageUrl, idCardSide) {
      // 显示加载提示
      const loading = this.$message.loading('正在识别身份证信息...', 0)

      // 识别前，如果是人像面，先重置性别为 undefined，以便判断是否识别到性别
      if (idCardSide === 'front') {
        this.form.sex = undefined
      }

      // 调用百度身份证识别API
      baiduVerification({
        image: imageUrl, // 图片URL
        idCardSide: idCardSide || 'front', // 默认正面
      })
        .then((res) => {
          loading()
          if (res.success && res.data) {
            const result = res.data
            const wordsResult = result.wordsResult

            if (!wordsResult) {
              this.$message.warning('未能识别到身份证信息', 3)
              // 识别失败，标记已识别但性别未识别到，允许用户手动选择
              this.hasIdCardRecognized = true
              if (idCardSide === 'front') {
                this.form.sex = undefined
              }
              return
            }

            // 回填表单信息（正面信息）
            if (idCardSide === 'front') {
              // 姓名
              if (wordsResult.name && wordsResult.name.words) {
                this.form.nickName = wordsResult.name.words
              }
              // 民族
              if (wordsResult.nation && wordsResult.nation.words) {
                this.form.nationality = wordsResult.nation.words
              }
              // 出生年月日（格式：YYYYMMDD，需要转换为YYYY-MM-DD）
              if (wordsResult.birth && wordsResult.birth.words) {
                const birthStr = wordsResult.birth.words
                // 尝试解析日期格式：YYYYMMDD 或 YYYY年MM月DD日
                let birthDate = null
                if (birthStr.length === 8 && /^\d{8}$/.test(birthStr)) {
                  // YYYYMMDD格式
                  birthDate =
                    birthStr.substring(0, 4) +
                    '-' +
                    birthStr.substring(4, 6) +
                    '-' +
                    birthStr.substring(6, 8)
                } else if (
                  birthStr.includes('年') &&
                  birthStr.includes('月') &&
                  birthStr.includes('日')
                ) {
                  // YYYY年MM月DD日格式
                  const match = birthStr.match(
                    /(\d{4})年(\d{1,2})月(\d{1,2})日/
                  )
                  if (match) {
                    const year = match[1]
                    const month = match[2].padStart(2, '0')
                    const day = match[3].padStart(2, '0')
                    birthDate = `${year}-${month}-${day}`
                  }
                }
                if (birthDate) {
                  this.form.birthDate = birthDate
                }
              }
              // 身份证号
              if (wordsResult.idNumber && wordsResult.idNumber.words) {
                this.form.idNumber = wordsResult.idNumber.words
              }
              // 处理性别识别
              if (wordsResult.gender && wordsResult.gender.words) {
                const genderStr = wordsResult.gender.words.trim()
                console.log('识别到的性别值:', genderStr)
                // 支持多种格式的性别值判断
                if (genderStr.includes('男') || genderStr === 'M' || genderStr === 'm' || genderStr.toLowerCase() === 'male') {
                  this.form.sex = 1
                  console.log('设置性别为: 1 (男)')
                } else if (genderStr.includes('女') || genderStr === 'F' || genderStr === 'f' || genderStr.toLowerCase() === 'female') {
                  this.form.sex = 2
                  console.log('设置性别为: 2 (女)')
                } else {
                  // 如果识别到性别但值不是"男"或"女"，设置为 undefined，让用户选择
                  console.log('性别值无法识别，设置为 undefined，允许用户手动选择')
                  this.form.sex = undefined
                }
              } else {
                // 如果没有识别到性别字段，明确设置为 undefined，让用户选择
                console.log('未识别到性别字段，设置为 undefined，允许用户手动选择')
                this.form.sex = undefined
              }
            } else if (idCardSide === 'back') {
              // 回填背面信息
              // 签发日期（格式：YYYYMMDD，需要转换为YYYY-MM-DD）
              if (wordsResult.issueDate && wordsResult.issueDate.words) {
                const issueDateStr = wordsResult.issueDate.words
                let issueDate = null
                if (issueDateStr.length === 8 && /^\d{8}$/.test(issueDateStr)) {
                  issueDate =
                    issueDateStr.substring(0, 4) +
                    '-' +
                    issueDateStr.substring(4, 6) +
                    '-' +
                    issueDateStr.substring(6, 8)
                } else if (
                  issueDateStr.includes('年') &&
                  issueDateStr.includes('月') &&
                  issueDateStr.includes('日')
                ) {
                  const match = issueDateStr.match(
                    /(\d{4})年(\d{1,2})月(\d{1,2})日/
                  )
                  if (match) {
                    const year = match[1]
                    const month = match[2].padStart(2, '0')
                    const day = match[3].padStart(2, '0')
                    issueDate = `${year}-${month}-${day}`
                  }
                }
                if (issueDate) {
                  this.form.cardStartTime = issueDate
                }
              }
              // 失效日期（格式：YYYYMMDD，需要转换为YYYY-MM-DD）
              if (wordsResult.expiryDate && wordsResult.expiryDate.words) {
                const expiryDateStr = wordsResult.expiryDate.words
                let expiryDate = null
                if (
                  expiryDateStr.length === 8 &&
                  /^\d{8}$/.test(expiryDateStr)
                ) {
                  expiryDate =
                    expiryDateStr.substring(0, 4) +
                    '-' +
                    expiryDateStr.substring(4, 6) +
                    '-' +
                    expiryDateStr.substring(6, 8)
                } else if (
                  expiryDateStr.includes('年') &&
                  expiryDateStr.includes('月') &&
                  expiryDateStr.includes('日')
                ) {
                  const match = expiryDateStr.match(
                    /(\d{4})年(\d{1,2})月(\d{1,2})日/
                  )
                  if (match) {
                    const year = match[1]
                    const month = match[2].padStart(2, '0')
                    const day = match[3].padStart(2, '0')
                    expiryDate = `${year}-${month}-${day}`
                  }
                }
                if (expiryDate) {
                  this.form.cardEndTime = expiryDate
                }
              }
            }

            // 识别成功后，标记已进行身份证识别
            this.hasIdCardRecognized = true
            this.$message.success('身份证信息识别成功，已自动回填', 3)
          } else {
            this.$message.warning(res.msg || '识别失败，请重试', 3)
            // 识别失败，标记已识别但性别未识别到，允许用户手动选择
            this.hasIdCardRecognized = true
            if (idCardSide === 'front') {
              this.form.sex = undefined
            }
          }
        })
        .catch((error) => {
          loading()
          console.error('调用百度身份证识别API失败', error)
          this.$message.error(
            error.msg || '识别失败，请检查网络连接或稍后重试',
            3
          )
          // 识别失败，标记已识别但性别未识别到，允许用户手动选择
          this.hasIdCardRecognized = true
          if (idCardSide === 'front') {
            this.form.sex = undefined
          }
        })
    },
    handleUserStatusChange(status) {
      if (status === '0' || status === 0) {
        if (!this.form.departTime) {
          this.form.departTime = moment().format('YYYY-MM-DD')
        }
      } else if (status === '1' || status === 1) {
        this.form.departTime = undefined
      }
    },
    /**
     * 禁用入职时间当天及之前的日期，确保离职时间必须在入职时间之后
     * @param {Object} current - moment对象，当前日期
     * @returns {Boolean} true-禁用该日期，false-不禁用
     */
    disabledDepartDate(current) {
      if (!this.form.entryTime || !current) {
        return false
      }
      try {
        // 将入职时间转换为 moment 对象
        const entryTime = moment(this.form.entryTime, 'YYYY-MM-DD')
        if (!entryTime.isValid()) {
          return false
        }
        // 如果 current 是 moment 对象，使用 moment 方法比较
        if (moment.isMoment(current)) {
          return current.isBefore(entryTime, 'day')
        }
        // 如果 current 是其他日期对象（如 dayjs），转换为 moment 后比较
        const currentMoment = moment(current)
        if (currentMoment.isValid()) {
          return currentMoment.isBefore(entryTime, 'day')
        }
        // 如果无法转换，使用原生 Date 比较
        const entryDate = entryTime.toDate()
        const currentDate = current instanceof Date ? current : new Date(current)
        return currentDate < entryDate
      } catch (error) {
        console.error('日期比较错误:', error)
        return false
      }
    },
    /** 处理机动人才证书上传（多图） */
    handleCertificateUrlChange(data) {
      // 多图上传时，getImg方法会emit一个对象，包含fieldName和fieldNameArr
      // fieldName字段的值是所有图片URL用逗号拼接的字符串
      if (typeof data === 'object' && data !== null) {
        // 如果传入的是对象，提取certificateUrl字段（逗号分隔的URL字符串）
        if (data.certificateUrl !== undefined) {
          // 确保是字符串格式，多个URL用逗号拼接
          this.form.certificateUrl = data.certificateUrl
        } else if (
          data.certificateUrlArr &&
          Array.isArray(data.certificateUrlArr)
        ) {
          // 如果没有certificateUrl字段，但有certificateUrlArr数组，手动拼接
          this.form.certificateUrl = data.certificateUrlArr
            .map((item) => item.url || item.path || item)
            .filter((url) => url)
            .join(',')
        }
      } else if (typeof data === 'string') {
        // 如果传入的是字符串（已经是逗号分隔的URL字符串或空字符串）
        this.form.certificateUrl = data
      } else {
        // 如果传入的是空值，清空
        this.form.certificateUrl = ''
      }
      console.log('机动人才证书URL:', this.form.certificateUrl)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      $emit(this, 'select-tree')
      getUser().then((response) => {
        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
        this.open = true
        this.formTitle = '新增用户'
        this.form.password = this.initPassword
        this.loadAttendanceOptions()
      })
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      $emit(this, 'select-tree')
      const userId = row ? row.id : ids
      getUser(userId).then((response) => {
        this.form = response.data.data
        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
        if (response.data.roleIds.length) {
          this.form.roleIds = response.data.roleIds[0]
        } else {
          this.form.roleIds = ''
        }
        // 处理项目授权数据
        if (this.form.projectCodes) {
          if (this.form.projectCodes === '0') {
            this.isAllProjectSelected = true
            this.selectedProjects = []
          } else {
            this.isAllProjectSelected = false
            // 将字符串转换为数组
            this.selectedProjects = this.form.projectCodes
              .split(',')
              .filter((v) => v && v !== '0')
          }
        } else {
          this.isAllProjectSelected = false
          this.selectedProjects = []
        }
        // 如果接口返回了身份证有效期，标记为接口值，应该禁用
        this.hasIdCardFromApi = !!(this.form.cardStartTime || this.form.cardEndTime)
        this.hasIdCardRecognized = false // 编辑模式下重置识别标记
        this.open = true
        this.formTitle = '修改用户'
        this.form.password = undefined
        this.handleUserStatusChange(this.form.userStatus)
        this.loadAttendanceOptions()
      })
    },
    /** 提交按钮 */
    submitForm: async function () {
      try {
        await this.$refs.formRef.validate()
        this.submitLoading = true
        if (this.form.roleIds) {
          this.form.roleIds = [this.form.roleIds]
        } else {
          this.form.roleIds = []
        }
        // 处理项目授权数据
        if (this.isAllProjectSelected) {
          this.form.projectCodes = '0'
        } else if (
          this.selectedProjects &&
          this.selectedProjects.length > 0
        ) {
          this.form.projectCodes = this.selectedProjects.join(',')
        } else {
          this.form.projectCodes = undefined
        }
        let response
        if (this.form.id !== undefined) {
          response = await updateUser(this.form)
        } else {
          response = await addUser(this.form)
        }

        // 检查响应状态码，只有 20001 才是成功
        const code = response?.code
        if (code == 20001 || code === 20001 || code === '20001') {
          this.$message.success(this.form.id !== undefined ? '修改成功' : '新增成功', 3)
          this.open = false
          $emit(this, 'ok')
        } else {
          // 失败时显示错误信息
          const errorMsg = response?.message || response?.msg || '操作失败，请稍后重试'
          this.$message.error(errorMsg, 3)
        }
      } catch (error) {
        // 处理请求异常
        let errorMessage = '操作失败，请稍后重试'
        if (error && error.response && error.response.data) {
          const data = error.response.data
          errorMessage = data.message || data.msg || errorMessage
        } else if (error && error.message) {
          errorMessage = error.message
        }
        this.$message.error(errorMessage, 3)
        return false
      } finally {
        this.submitLoading = false
      }
    },
  },
  emits: ['select-tree', 'ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 60px 24px !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
}

/* Label 文字右对齐，与输入框水平排列 */
.create-form-modal .ant-form-item-label {
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
  text-align: right !important;
  padding-right: 8px !important;
  flex: 0 0 150px !important;
}

.create-form-modal .ant-form-item-label>label {
  width: 100%;
  text-align: right !important;
  justify-content: flex-end !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* 确保表单项是水平布局 */
.create-form-modal .ant-form-item {
  display: flex !important;
  flex-direction: row !important;
}

.create-form-modal .ant-form-item-control {
  flex: 1 !important;
  min-width: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 确保表单项不会超出 */
.create-form-modal .ant-form-item {
  margin-bottom: 24px !important;
  overflow: visible !important;
  width: 100% !important;
  max-width: 100% !important;
}

.create-form-modal .ant-form-item-control {
  max-width: 100% !important;
  overflow: hidden !important;
  width: 100% !important;
}

/* 富文本编辑器外层容器 - 防止超出 */
.create-form-modal .ant-form-item-control-input-content {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
  display: flex !important;
  flex-direction: row !important;
}

/* 两列布局中的 label 样式 */
.two-column-form :deep(.ant-form-item-label) {
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
  text-align: right !important;
  padding-right: 8px !important;
  flex: 0 0 150px !important;
  margin-right: 0 !important;
}

.two-column-form :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right !important;
  justify-content: flex-end !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.two-column-form :deep(.ant-form-item-control) {
  flex: 1 !important;
  min-width: 0 !important;
}

/* 整列表单项样式 */
.two-column-form :deep(.ant-col-24) {
  width: 100%;
  max-width: 100%;
}

/* 上传组件水平居中排布样式 */
.two-column-form :deep(.ant-col-8) {
  width: 33.333333%;
  max-width: 33.333333%;
}

.two-column-form :deep(.ant-col-8:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-8:last-child) {
  padding-left: 6px !important;
}

.two-column-form :deep(.ant-col-8:not(:first-child):not(:last-child)) {
  padding-left: 3px !important;
  padding-right: 3px !important;
}

/* 上传组件的表单项样式 - 垂直居中布局 */
.two-column-form :deep(.ant-col-8 .ant-form-item) {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
}

.two-column-form :deep(.ant-col-8 .ant-form-item-label) {
  width: 100% !important;
  text-align: center !important;
  margin-bottom: 8px !important;
  flex: none !important;
  padding-right: 0 !important;
}

.two-column-form :deep(.ant-col-8 .ant-form-item-label > label) {
  text-align: center !important;
  justify-content: center !important;
  width: 100% !important;
}

.two-column-form :deep(.ant-col-8 .ant-form-item-control) {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
  flex: none !important;
}

/* Radio Button 样式 - 性别和状态 */
.create-form-modal .ant-radio-button-wrapper {
  border-radius: 4px !important;
}

.create-form-modal .ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px !important;
}

.create-form-modal .ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0 !important;
}

.create-form-modal .ant-radio-button-wrapper-checked {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.create-form-modal .ant-radio-button-wrapper-checked::before {
  background-color: #165DFF !important;
}
</style>
